import { MultipleInsurance } from "@app/components/ui/inputs/multipleInsurancesSelector/multipleInsurancesSelector";
import {
  SubSteps,
  PaymentInfo,
  PaymentType,
} from "@app/pages/private/simpleOrder/paymentMethod/paymentMethod";
import { StepState, StepId, StepData } from "@natera/stepper";
import { PredefinedCompanyName } from "@app/components/companySelector/companySelector";

export const getDataFromMultipleSecondStep = (
  steps: StepState[]
): PaymentInfo => {
  const stepsMap: Record<StepId, StepData> = {};
  steps.forEach((step) => {
    stepsMap[step.stepId] = step.data;
  });

  if (stepsMap[SubSteps.MULTIPLE_SECOND] === MultipleInsurance.Government) {
    const companyName =
      stepsMap[SubSteps.SELECT_GOVERNMENT_COMPANY_SECOND].companyName ===
      PredefinedCompanyName.Other
        ? stepsMap[SubSteps.ENTER_OTHER_GOVERNMENT_COMPANY_SECOND]
            .otherCompanyName
        : stepsMap[SubSteps.SELECT_GOVERNMENT_COMPANY_SECOND].companyName;

    const companyGroupId =
      stepsMap[SubSteps.SELECT_GOVERNMENT_COMPANY_SECOND].companyName ===
      PredefinedCompanyName.Other
        ? stepsMap[SubSteps.ENTER_OTHER_GOVERNMENT_COMPANY_SECOND]
            .otherCompanyGroupId
        : stepsMap[SubSteps.SELECT_GOVERNMENT_COMPANY_SECOND].companyGroupId;

    return {
      paymentMethod: PaymentType.GOVERNMENT_ISSUED,
      paymentMethodInfo: {
        companyName,
        insuranceNumber:
          stepsMap[SubSteps.PROVIDE_GOVERNMENT_INSURANCE_SECOND]
            .insuranceNumber,
        companyGroupId,
      },
    };
  } else {
    const companyName =
      stepsMap[SubSteps.SELECT_COMMERCIAL_COMPANY_SECOND].companyName ===
      PredefinedCompanyName.Other
        ? stepsMap[SubSteps.ENTER_OTHER_COMMERCIAL_COMPANY_SECOND]
            .otherCompanyName
        : stepsMap[SubSteps.SELECT_COMMERCIAL_COMPANY_SECOND].companyName;

    const companyGroupId =
      stepsMap[SubSteps.SELECT_COMMERCIAL_COMPANY_SECOND].companyName ===
      PredefinedCompanyName.Other
        ? stepsMap[SubSteps.ENTER_OTHER_COMMERCIAL_COMPANY_SECOND]
            .otherCompanyGroupId
        : stepsMap[SubSteps.SELECT_COMMERCIAL_COMPANY_SECOND].companyGroupId;

    return {
      paymentMethod: PaymentType.COMMERCIAL,
      paymentMethodInfo: {
        companyName,
        memberId:
          stepsMap[SubSteps.PROVIDE_COMMERCIAL_INSURANCE_SECOND].memberId,
        companyGroupId,
      },
    };
  }
};
